<template>
  <div class="offer-plan-box">
    <h4 class="text-semibold mb-5">
      {{ isSignature ? "Planos Salvos" : "Ofertas Salvas" }}
    </h4>

    <span v-if="!items.length">
      <h4 class="text-center fs-24 text-semibold">
        Você não possui
        {{ isSignature ? "nenhum plano salvo" : "nenhuma oferta salva" }}
        no momento
      </h4>
      <img class="d-block mt-5 mx-auto" src="@/assets/images/no-content.svg" />
    </span>

    <OfferOrPlanItem
      v-else
      v-for="(item, index) in items"
      :key="index"
      :item="item"
      :index="index"
      :isSignature="isSignature"
      @edit="e => editItems(e)"
      @delete="e => toggleModal(e)"
      @removeOrderBump="
        orderBumpIndex => $emit('removeOrderBump', index, orderBumpIndex)
      "
    />

    <bp-dialog
      v-bind="deleteDialog"
      @action="closeModal"
      @secondary-action="removeItem"
    />
  </div>
</template>

<script>
import moment from "moment";
import OfferOrPlanItem from "./OfferOrPlanItem.vue";

export default {
  components: {
    OfferOrPlanItem
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isSignature: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      indexToDelete: null,
      deleteDialog: {
        variant: "negative",
        value: false,
        text: `Tem certeza que deseja excluir ${
          this.isSignature ? "o plano" : "a oferta"
        }?`,
        icon: "fa fa-circle-trash",
        buttonText: "Não",
        secondaryButtonText: "Sim"
      }
    };
  },
  methods: {
    formatDate(item) {
      const start = moment(item.start_at).format("DD/MM/YYYY");
      if (item.end_at) {
        const end = moment(item.end_at).format("DD/MM/YYYY");
        return `${start} - ${end}`;
      }
      return `Inicia em ${start}, sem data limite.`;
    },
    editItems(index) {
      this.$emit("edit", index);
    },
    removeItem() {
      this.$emit("delete", this.indexToDelete);
      this.deleteDialog.value = false;
    },
    toggleModal(index) {
      this.deleteDialog.value = true;
      this.indexToDelete = index;
    },
    closeModal() {
      this.deleteDialog.value = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.offer-plan-box {
  @media screen and (max-width: 991px) {
    h6 {
      font-size: 16px;
    }
  }

  .container-selected {
    padding: 12px 20px;
    border-radius: 4px;
    border: 1px solid #d2d0d8;
    position: relative;
    width: 100%;
    transition: 0.3s all ease-in-out;

    &:not(:first-child) {
      margin-top: 8px;
    }

    span {
      font-weight: normal !important;
    }
    &:has(div.show) {
      background-color: white;
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
    }
  }
  .square-divider {
    width: 4px;
    height: 4px;
    background: #acabae;
    border-radius: 8px;
  }
}
</style>
